import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";
import { NSLoading } from "namirasoft-site-react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { AccessRoutes } from "../AccessRoutes";

interface PermissionViewDecisionPageProps extends NSARouterMakerResult, AccessProps
{ }

export default function PermissionViewDecisionPage(props: PermissionViewDecisionPageProps)
{
	let { id } = useParams();

	useEffect(() =>
	{
		if (id)
		{
			props.servers.access.permission.GetOutgoing(id, { onError: () => { } }).then(() =>
			{
				if (id)
					props.url.redirect(AccessRoutes.OutgoingPermissionView(id), {});
			}).catch(() =>
			{
				if (id)
					props.url.redirect(AccessRoutes.IncomingPermissionView(id), {});
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps 
	}, []);

	return (
		<AccessLayout {...props}
			action={{ title: 'Redirecting', description: '', menus: {} }}>
			<NSLoading title="Redirecting" />
		</AccessLayout >
	);
}